import React from 'react';
import { CSS_VARIABLE_STAGE_VISIBLE_SCALE } from '../../../constants/stage-css-variables';
import { CANVAS } from '../../../constants/template-builder';
type CanvasEdgePropsT = {
  fromPosition: [number, number];
  toPosition: [number, number];
  strokeColor: string;
  highlighted: boolean;
  onHover: (hovered: boolean) => void;
};
export function CanvasEdge({
  fromPosition,
  toPosition,
  strokeColor,
  highlighted,
  onHover
}: CanvasEdgePropsT) {
  const baseWidth = highlighted ? CANVAS.EDGE_HOVER_STROKE_WIDTH : CANVAS.EDGE_STROKE_WIDTH;
  const scaledStrokeWidth = `calc(${baseWidth}px * var(${CSS_VARIABLE_STAGE_VISIBLE_SCALE}))`;
  const scaledHitArea = `calc(${CANVAS.EDGE_HIT_AREA_WIDTH}px * var(${CSS_VARIABLE_STAGE_VISIBLE_SCALE}))`;
  return <g style={{
    cursor: 'pointer',
    pointerEvents: 'auto'
  }} onPointerUp={e => e.stopPropagation()} onPointerEnter={() => onHover(true)} onPointerLeave={() => onHover(false)}>
      <line x1={fromPosition[0]} y1={fromPosition[1]} x2={toPosition[0]} y2={toPosition[1]} stroke="transparent" style={{
      strokeWidth: scaledHitArea
    }} />
      <line x1={fromPosition[0]} y1={fromPosition[1]} x2={toPosition[0]} y2={toPosition[1]} stroke={strokeColor} style={{
      strokeWidth: scaledStrokeWidth,
      pointerEvents: 'none'
    }} />
    </g>;
}